import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames/bind'

import SectionLoader from '../SectionLoader'

import styles from './GoodToKnowSection.module.scss'

const cx = classnames.bind(styles);

const GoodToKnowSection = function ({
  className = '',
  info,
  isLoading = true,
}) {
  return (
    <div className={cx('root', className)}>
      {isLoading && <SectionLoader className={cx('root', 'loader-root')} />}
      {!isLoading && !!info?.text?.length && (
        <div className={cx('content')} dangerouslySetInnerHTML={{__html: info.text}} />
      )}
    </div>
  )
}

GoodToKnowSection.propTypes = {
  data: PropTypes.any
}

export default GoodToKnowSection;
